import Modal from 'LuxKit/Modal/Modal'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import React from 'react'
import { useIntl } from 'react-intl'

interface TProps {
  remainingTime: {
    hours: number
    minutes: number
  }
}

function RemainingTimeModal({ remainingTime }: TProps) {
  const { hours, minutes } = remainingTime
  const intl = useIntl()

  const remainingTimeCopy = hours > 0
    ? intl.formatMessage(
        {
          id: 'TLlD5MTPJY',
          defaultMessage: '{count, plural, one {# hour} other {# hours}}',
          description: 'Pluralized hours for remaining time to add cancellation protection',
        },
        { count: hours },
      )
    : intl.formatMessage(
        {
          id: '2O3bpk/Y79',
          defaultMessage: '{count, plural, one {# minute} other {# minutes}}',
          description: 'Pluralized minutes for remaining time to add cancellation protection',
        },
        { count: minutes },
      )

  const title = intl.formatMessage({
    id: '7Iht6gii1J',
    defaultMessage: 'Cancellation protection',
    description: 'Title for the remaining time cancellation protection modal',
  })

  const bodyText = intl.formatMessage(
    {
      id: 'bXr/qNeVe2',
      defaultMessage: 'You have {remainingTime} to add cancellation protection. After that, it’s no longer available\u2014this limit is set by our partner, XCover.',
      description: 'Body text explaining the time remaining to add cancellation protection',
    },
    { remainingTime: remainingTimeCopy },
  )

  return (
    <Modal title={title}>
      <BodyTextBlock variant="medium">
        {bodyText}
      </BodyTextBlock>
    </Modal>
  )
}

export default RemainingTimeModal
